import React from "react";
import {PRIVACY_POLICY_DOC_URL} from "../../Config/Router/Routes";

interface Props{
    classes?: string
}

export const PrivacyPolicyLink : React.FC<Props> = (props: Props) => {

    return (
        <a href={PRIVACY_POLICY_DOC_URL} target={"_blank"} className={props.classes ?? ''}>Política de Privacidad</a>
    )

}